import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import { Stack } from 'react-bootstrap';
import { useParams, useNavigate, Link } from "react-router-dom";
import { useAppContext } from "../../../libs/contextLib";
import { useTranslation } from 'react-i18next';
import ROSBagFileListTable from "../EA/ROSBagFileListTable";
import ResultReport from "./ResultReport";

function EAManage() {
    const { t } = useTranslation();
    const { isAuthenticated } = useAppContext();
    const [isLoading, setIsLoading] = useState(true);
    const history = useNavigate();
    const { currentLocation, setCurrentLocation } = useAppContext();
    setCurrentLocation('/da/acquisition-status');

    useEffect(() => {
        async function onLoad() {

        }

        onLoad();
    }, []);

    return (
        <div className="page-content">
            <div className="content-section">
                <Stack gap={3}>
                    <div className="bg-light">
                        <ROSBagFileListTable />
                    </div>
                    <div className="bg-light">
                        <ResultReport />
                    </div>

                </Stack>
            </div>
        </div>
    );
};

export default EAManage;